import { render, staticRenderFns } from "./CertificateLeadersDetails.vue?vue&type=template&id=dfd943ba&scoped=true"
import script from "./CertificateLeadersDetails.vue?vue&type=script&lang=js"
export * from "./CertificateLeadersDetails.vue?vue&type=script&lang=js"
import style0 from "./CertificateLeadersDetails.vue?vue&type=style&index=0&id=dfd943ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfd943ba",
  null
  
)

export default component.exports